import cloneDeep from 'lodash/cloneDeep';
import {ActionType} from '../actionTypes/foedus';

const initialState = {
	addMultipleOrganOffersModalOpen: false,
	changeRecipientsModalOpen: false,
	notificationModalOpen: false,
	messageModalOpen: false,
	acceptOrganOfferModalOpen: false,
	declineOrganOfferModalOpen: false,
	grantAnonymousAccessModalOpen: false,
	showNotificationActionButton: false,
	showMessageActionButton: false,
	showGrantAnonymousAccessActionButton: false,
	organOfferAttachmentTypeCbIds: null,
	nationalBodyCoreCodebook: null,
	countryCoreCodebook: null,
	foedusRoles: null,
	loggedUserPrimaryFoedusRole: null,
	loggedUserCountry: null,
	loggedUserFoedusPerson: null,
	foedusRoleNamesFilter: null,
	regDevicesUniqueCountries: null,
	regDevicesUniqueOrganizations: null,
	regDevicesUniqueFoeudusPersons: null
};

const foedus = (state = initialState, action) => {
	const { type, payload } = action;
	let foedusState = cloneDeep(state);

	switch (type) {
		case ActionType.OPEN_MULTIPLE_ORGAN_OFFERS_MODAL:
			foedusState.addMultipleOrganOffersModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_MULTIPLE_ORGAN_OFFERS_MODAL:
			foedusState.addMultipleOrganOffersModalOpen = false;
			return foedusState;
		case ActionType.OPEN_CHANGE_RECIPIENTS_MODAL:
			foedusState.changeRecipientsModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_CHANGE_RECIPIENTS_MODAL:
			foedusState.changeRecipientsModalOpen = false;
			return foedusState;
		case ActionType.OPEN_NOTIFICATION_MODAL:
			foedusState.notificationModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_NOTIFICATION_MODAL:
			foedusState.notificationModalOpen = false;
			return foedusState;
		case ActionType.OPEN_MESSAGE_MODAL:
			foedusState.messageModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_MESSAGE_MODAL:
			foedusState.messageModalOpen = false;
			return foedusState;
		case ActionType.OPEN_ACCEPT_ORGAN_OFFER_MODAL:
			foedusState.acceptOrganOfferModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_ACCEPT_ORGAN_OFFER_MODAL:
			foedusState.acceptOrganOfferModalOpen = false;
			return foedusState;
		case ActionType.OPEN_DECLINE_ORGAN_OFFER_MODAL:
			foedusState.declineOrganOfferModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_DECLINE_ORGAN_OFFER_MODAL:
			foedusState.declineOrganOfferModalOpen = false;
			return foedusState;
		case ActionType.OPEN_GRANT_ANONYMOUS_ACCESS_MODAL:
			foedusState.grantAnonymousAccessModalOpen = true;
			return foedusState;
		case ActionType.CLOSE_GRANT_ANONYMOUS_ACCESS_MODAL:
			foedusState.grantAnonymousAccessModalOpen = false;
			return foedusState;
		case ActionType.SHOW_NOTIFICATION_ACTION_BUTTON:
			foedusState.showNotificationActionButton = true;
			return foedusState;
		case ActionType.HIDE_NOTIFICATION_ACTION_BUTTON:
			foedusState.showNotificationActionButton = false;
			return foedusState;
		case ActionType.SHOW_MESSAGE_ACTION_BUTTON:
			foedusState.showMessageActionButton = true;
			return foedusState;
		case ActionType.HIDE_MESSAGE_ACTION_BUTTON:
			foedusState.showMessageActionButton = false;
			return foedusState;
		case ActionType.SHOW_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON:
			foedusState.showGrantAnonymousAccessActionButton = true;
			return foedusState;
		case ActionType.HIDE_GRANT_ANONYMOUS_ACCESS_ACTION_BUTTON:
			foedusState.showGrantAnonymousAccessActionButton = false;
			return foedusState;
		case ActionType.SET_ORGAN_OFFER_ATTACHMENT_TYPE_IDS:
			foedusState.organOfferAttachmentTypeCbIds = payload.organOfferAttachmentTypeCbIds;
			return foedusState;
		case ActionType.SET_NATIONAL_BODY_CORE_CODEBOOK:
			foedusState.nationalBodyCoreCodebook = payload.nationalBodyCoreCodebook;
			return foedusState;
		case ActionType.SET_COUNTRY_CORE_CODEBOOK:
			foedusState.countryCoreCodebook = payload.countryCoreCodebook;
			return foedusState;
		case ActionType.SET_LOGGED_USER_PRIMARY_FOEDUS_ROLE:
			foedusState.loggedUserPrimaryFoedusRole = payload.loggedUserPrimaryFoedusRole;
			return foedusState;
		case ActionType.SET_LOGGED_USER_COUNTRY:
			foedusState.loggedUserCountry = payload.loggedUserCountry;
			return foedusState;
		case ActionType.SET_LOGGED_USER_FOEDUS_PERSON:
			foedusState.loggedUserFoedusPerson = payload.loggedUserFoedusPerson;
			return foedusState;
		case ActionType.SET_FOEDUS_ROLE_NAMES_FILTER:
			foedusState.foedusRoleNamesFilter = payload.foedusRoleNamesFilter;
			return foedusState;
		case ActionType.SET_REG_DEVICES_UNIQUE_COUNTRIES:
			foedusState.regDevicesUniqueCountries = payload.regDevicesUniqueCountries;
			return foedusState;
		case ActionType.SET_REG_DEVICES_UNIQUE_ORGANIZATIONS:
			foedusState.regDevicesUniqueOrganizations = payload.regDevicesUniqueOrganizations;
			return foedusState;
		case ActionType.SET_REG_DEVICES_UNIQUE_FOEDUS_PERSONS:
			foedusState.regDevicesUniqueFoeudusPersons = payload.regDevicesUniqueFoeudusPersons;
			return foedusState;
		default:
			return state;
	}
};

export default foedus;
